var el = jQuery( '.c-header' );
el.addClass( 'c-header--top' );

jQuery( window ).on('scroll', function( event ){
	var scrollTop = jQuery( this ).scrollTop();

	if ( scrollTop > 0 ) {
		el.removeClass( 'c-header--top' ).addClass( 'c-header--not-top' );
	} else {
		el.removeClass( 'c-header--not-top' ).addClass( 'c-header--top' );
	}
})
